import { render, staticRenderFns } from "./CustomizedBenefitsHome.vue?vue&type=template&id=2312b754&scoped=true"
import script from "./CustomizedBenefitsHome.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomizedBenefitsHome.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2312b754",
  null
  
)

export default component.exports